export default "__VITE_ASSET__Dulvkar6__"